// extracted by mini-css-extract-plugin
export default {"alertEventIncidentsTableContainer":"alert-event-incidents-table-container__alert-event-incidents-table-container__DY4qG"};